interface StructuredError {
  message?: unknown;
  details?: unknown;
  hint?: unknown;
  code?: unknown;
}

function nonEmptyString(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

const SCHEMA_REPAIRS: Readonly<Record<string, string>> = {
  lesson_number: '0007_repair_lesson_number_sync.sql',
};

function schemaRepair(message: string | null, code: string | null): string | null {
  if (code !== 'PGRST204' || !message) return null;

  const column = /(?:find the ['"]|column ['"]?)([a-z0-9_]+)/i.exec(message)?.[1];
  const migration = column && SCHEMA_REPAIRS[column];
  return migration
    ? `Base de données non mise à jour : exécutez ${migration} dans l’éditeur SQL Supabase.`
    : null;
}

/**
 * Supabase errors are plain objects rather than `Error` instances. Turning one
 * into a string directly only produces "[object Object]", which hides the
 * information needed to repair a failed synchronisation.
 */
export function formatSyncError(error: unknown): string {
  if (error instanceof Error) return error.message || error.name;
  if (typeof error === 'string') return error;

  if (error && typeof error === 'object') {
    const structured = error as StructuredError;
    const message = nonEmptyString(structured.message);
    const details = nonEmptyString(structured.details);
    const hint = nonEmptyString(structured.hint);
    const code = nonEmptyString(structured.code);
    const repair = schemaRepair(message, code);
    if (repair) return repair;
    const parts = [message, details, hint].filter(
      (part, index, all): part is string => Boolean(part) && all.indexOf(part) === index,
    );

    if (parts.length) return `${parts.join(' — ')}${code ? ` (${code})` : ''}`;

    try {
      return JSON.stringify(error);
    } catch {
      // A circular third-party object has no useful serialisation.
    }
  }

  return String(error);
}
